<script setup lang="ts">
import { computed } from "vue";
import { responsiveClass, responsiveVariables } from "../../utilities/helpers";
import type { IStackItemProps } from "./VStack.types";

const props = defineProps<IStackItemProps>();

const rootClass = computed(() => {
  return [
    "pl-stack-item",
    ...responsiveClass("pl-stack-item_grow", props.grow),
    ...responsiveClass("pl-stack-item_size", props.size),
  ];
});

const rootVariables = computed(() => {
  return {
    ...responsiveVariables("--_o", props.order),
  };
});
</script>

<template>
  <div :class="rootClass" :style="rootVariables">
    <slot />
  </div>
</template>

<style lang="postcss" scoped>
.pl-stack-item {
  &_grow {
    flex: 1 1 0;
    min-width: 0;
  }

  &_size-auto {
    width: auto;
  }

  @each $column in 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 {
    &_size-$(column) {
      width: calc(
        (100% / (12 / $(column))) -
          (var(--pl-stack-gap) - (var(--pl-stack-gap) / (12 / $(column))))
      );
    }
  }
}

@each $breakpoint in s, m, ml, l, xl {
  @media (--pl-viewport-from-$(breakpoint)) {
    .pl-stack-item {
      &_grow-false-$(breakpoint) {
        flex: 0 0 auto;
      }

      &_grow-true-$(breakpoint) {
        flex: 1 1 0;
      }

      &_size-auto-$(breakpoint) {
        width: auto;
      }

      @each $column in 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 {
        &_size-$(column)-$(breakpoint) {
          width: calc(
            (100% / (12 / $(column))) -
              (var(--pl-stack-gap) - (var(--pl-stack-gap) / (12 / $(column))))
          );
        }
      }
    }
  }
}
</style>
